import "./YearSlider.scss"
import React, {useState} from "react";
import type {SliderSingleProps} from 'antd';
import {Slider} from "antd";
import {queryStringToObject, updateQueryString} from "../../../util/url";

export function YearSlider(p: {
  header: boolean,
  navigate: boolean,
  onChange?: (year: number[]) => void }
) {

  // get current year
  const y = (new Date).getFullYear()

  // get query string objecty
  const qso: { year: string } = queryStringToObject(window.location.href)
  const [miY,mxY] = qso.year?qso.year.split("-"):[y-2,y]

  const marks: SliderSingleProps['marks'] = {}
  marks[y - 1] = "Завершені"
  marks[y] = y.toString()
  marks[y + 1] = (y + 1).toString()
  marks[y + 2] = (y + 2).toString()

  const [min,setMin] = useState(Number(miY))
  const [max,setMax] = useState(Number(mxY))

  const [value, setValue] = useState<number[]>([min,max])

  return <>
    {p.header ? <h4>Квартири {min}-{max} р. побудови</h4> : null}
    <Slider
      range
      marks={marks}
      max={y + 2} min={y - 1}
      defaultValue={value}
      onChangeComplete={(v:number[]) => {
        setValue(v)
        setMin(v[0])
        setMax(v[1])
        if (p.navigate) {
          updateQueryString({year: v.join('-')})
        } else {
          if (p.onChange) p.onChange(v)
        }
      }}/>
  </>
}